// extracted by mini-css-extract-plugin
export var actionIcon = "_om-0";